// extracted by mini-css-extract-plugin
export default {"row":"LeaveWorkspaceModalBody_row__XXfEL","meta":"LeaveWorkspaceModalBody_meta__RXVfu"};